// note: we only return visited and edited types for my activity
/// <amd-module name="WorkItemsHub/Constants" />

export const MyActivityDateFieldValues = {
    // [WorkItemRecentActivityType[WorkItemRecentActivityType.Visited]]:
    // Resources.MyActivityDetailsViewed,
    // [WorkItemRecentActivityType[WorkItemRecentActivityType.Edited]]:
    // Resources.MyActivityDetailsUpdated
};

export namespace ActionUrl {
    export const ACTION: string = "action";
    export const ACTION_QUERY: string = "query";
    export const ACTION_EDIT: string = "edit";
}

export namespace ActionParameters {
    export const TEMPQUERYID: string = "tempQueryId";
    export const PATH: string = "path";
    export const ID: string = "id";
    export const IMPORTDATA: string = "importData";
}

export namespace FeatureFlags {
    export const UseTokenFiltering: string = "WebAccess.WorkItemTracking.UseTokenFiltering";
}

export const WorkItemsHubViewName = "new-work-items-hub-view"; // this is defined at vss-work-web.json
export const WorkItemsHubTabGroupContributionId = "ms.vss-work-web.new-work-items-hub-tab-group";
export const WorkItemsHubRouteId = "ms.vss-work-web.new-work-items-hub-view-route";
export const CreateWorkItemRouteId = "ms.vss-work-web.work-items-create-route";
export const OpenWorkItemRouteId = "ms.vss-work-web.work-items-form-route-with-id";
export const QueriesRouteId = "ms.vss-work-web.query-route-basic";

export const TabContent_BaseClassName = "work-items-tab-content";
export const TabContent_GridBaseClassName = "work-items-hub-grid";
export const TabContent_WorkItemsHubDetailsListClassName = "work-items-hub-detailslist";
export const TabContent_WorkItemsHubGridRowClassName = "work-items-hub-row";
